module.exports = __webpack_public_path__ + "img/logo-hemoce.ad8845f9.png";